export const campaignEnum = {
   TOP_25: 'top25under25',
   TOP_25_OPENED: 'top25opened'
};
